<template>
  <div>
    <products>
      <template v-slot="{ maxdevices, unlimited }">
        <div>
          <status></status>
          <div><h6>DEVICES<highlight-button></highlight-button></h6></div>
          <div v-if="items.length === 0">You do not have any devices registered.</div>
          
          <div v-if='unlimited'>Your account allows unlimited registered devices to be active at the same time.</div>
          <div v-if='! unlimited'>Your account allows {{ maxdevices }} registered devices to be active at the
             same time, as well as one that can be connected by logging in to this portal and clicking "connect". </div>
          <div v-if='! unlimited'>In order to increase your device limit, please <router-link v-if="account.subscription || account.flexiplan" to="/adjustplan">upgrade your current plan</router-link><router-link v-else-if="!account.subscription && !account.flexiplan" to="/buysubscribe">buy access for your preferred tier</router-link>.</div>
          <br />

          <button class="add-device-button" @click="showModal = true; modalErrorMessage= ''">Add New Device</button>
          <br />
          <button class="add-device-button mt-n3" @click="deviceOrderModal = true">Change Device Order</button>
          
          <div v-for="(device, index) in items" :key="device.macaddress + device.priority">
            <div v-if="! unlimited && maxdevices == index">
              <hr />
              <h6 class="pb-2">OTHER DEVICES - {{items.length - 2}} </h6>
            </div>
            <CCard :class="'device-style' + (!unlimited && maxdevices <= index ? ' device-disabled' : '')">
              <CCardHeader :class="'header-style' + (!unlimited && maxdevices <= index ? ' device-disabled' : '')">
                <span v-if="device.description">{{ device.description }} - </span>
                {{ device.devicetype.description }}
                <b v-if="maxdevices > index" class="active-label">ACTIVE</b><b class="inactive-label" v-else>INACTIVE</b>
              </CCardHeader>
              <CCardBody>
                <CContainer>
                  <CRow>
                    <CCol xs="1" sm="1" md="1" lg="1">
                      <devicetype :devicetype="device.devicetype"/>
                    </CCol>
                    <CCol xs="6" sm="6" md="6" lg="6">
                      <div title="This is also known as wi-fi address or ethernet address">
                        MAC - {{ device.macaddress }}
                      </div>
                    </CCol>
                    <CCol xs="4" sm="4" md="4" lg="4">
                      <highlight-button></highlight-button>
                    </CCol>
                    <CCol xs="1" sm="1" md="1" lg="1" title="Connection status"
                      ><devicestatus style="min-width:1rem" :device="device" />
                    </CCol>
                  </CRow>
                </CContainer>
              </CCardBody>
            </CCard>

          </div>
          <device-modal :isOpen="showModal" :errorMessage='modalErrorMessage' 
            @closeModal="showModal = false" 
            @newDevice="addDevice" @clear-error-message='clearErrorMessage' />
          <device-order-modal
            :visible.sync = "deviceOrderModal"
            :devices="items"
            @update:devices='orderDevices'
            :max="maxdevices"
          >
          </device-order-modal>
        </div>
      </template>
    </products>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Devicetype from "../Devicetype.vue";
import Devicestatus from "../Devicestatus.vue";
import Products from "./Products.vue";
import Status from "./Status.vue";
import DeviceModal from '../devices/DeviceModal.vue';
import DeviceOrderModal from '../devices/DeviceOrderModal';
import HighlightButton from '../general/HighlightButton';
import { mapGetters } from 'vuex';

export default {
  name: "Usage",
  // props: {
  //   account: {
  //     type: Object,
  //   },
  // },
  components: {
    Devicetype,
    Devicestatus,
    Products,
    Status,
    DeviceModal,
    DeviceOrderModal,
    HighlightButton
  },
  computed: {
    ...mapState('captive', ['onnet']),
    ...mapGetters({
      account: "account/account"
    }),
  },
  data: () => ({
    items: [],
    showModal: false,
    modalErrorMessage: "",
    deviceOrderModal: false
  }),
  methods: {
    addDevice(device) {
      this.$portalapi
      .get("/device/add", { params: { 
        macaddress: device.macAddress.address,
        description: device.description,
        priority: this.items.length + 1,
        type: device.deviceType } } )
      .then((response) => {                
        this.items = response.data;
        this.showModal = false;  // close the modal after adding a device
      })
      .catch((error) => {
        // response should have a code on why it cant be added
        if ( error.response && error.response.data){
          const errorType = error.response.data.errorType;
          const errorMessage = error.response.data.message;

          if ( errorType === 'SAMEUSER') {
            // registered to someone else
            this.modalErrorMessage = "That device is already registered to your account."
          } else if ( errorType === 'OTHERUSER') {
            // not checked just now
            this.modalErrorMessage = "That device is already registered to someone else. They will need to remove it from their account first."
          } else {
            this.$log.onError("Unable to add device", error)
          }
        }
      });
      
    },
    orderDevices(ordered){
      this.$log.onDebug("Saving ordered devices:" + JSON.stringify(ordered))


      let priorities = ordered
        .map((row, index) => {
          return {
            macaddress: row.macaddress,
            priority: index + 1
          };
        }).sort((a, b) => {
          return a.priority - b.priority
        });
      this.$log.onDebug(JSON.stringify(priorities))
      let payload = {
        username: this.account.username,
        priorities: priorities,
      };
      
      this.$portalapi.post('device/setpriorities', payload).then(
        (response) => {
          this.$log.onDebug('Devices returned now ordered as ' + JSON.stringify(response.data))
          let rd = response.data    
          if ( rd )      
            this.items = rd.sort((a, b) => {
              return a.priority - b.priority
            })
        },
        (error) => {
          this.$log.onError("error updating devices");
          this.$log.onError(error);
        }
      );
          
    },
    clearErrorMessage(){
      this.modalErrorMessage = ""
    }
  },
  created: function () {
    this.$portalapi
      .get("/myaccount/devices")
      .then((response) => {
        // device data should be sorted but lets not take a chance
        let rd = response.data    
        if ( rd )      
          this.items = rd.sort((a, b) => {
            return a.priority - b.priority
          })
      })
      .catch((error) => {
        this.$log.onError("error fetching devices");
      });
    
  },
};
</script>

<style lang="scss" scoped>

.device-style {
  border-radius: 10px 10px 10px 10px !important;
}

.header-style {
  border-radius: 8px 8px 0px 0px !important;
}

.device-disabled {
  background-color: #bebeb9;
  color: rgb(255, 51, 51);
  font-weight: 600;
}

.active-label {
  float: right;
  color: purple;
}

.inactive-label {
  float: right;
  color: red;
}

.card-header:first-child {
  border-radius: 2rem 2rem 0 0;
}

.add-device-button {
  border-radius: 16px;
  padding: 5px 2rem;
  background: linear-gradient(#a143a1, #512051);
  border: 1px solid lightgray;
  color: white;
  font-weight: bold;
  margin: 0 auto 1rem auto;
}

.add-device-button:hover {
  background: linear-gradient(#a356a3, #4a264a);
  transform: scale(1.05);
}

</style>
